// extracted by mini-css-extract-plugin
export default {"name":"FilterBlockReadonly-module__name___Fprsn","row":"FilterBlockReadonly-module__row___sDS71"};